import loadable from '@loadable/component';

/**
 * Code-split wrapper for ExitIntentSavePrompt — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
export const ExitIntentSavePrompt = loadable(
    /* #__LOADABLE__ */
    () => import('./ExitIntentSavePrompt'),
    {
        resolveComponent: (components) => components.ExitIntentSavePrompt,
        ssr: false,
    }
);
